export class DialogModelUploadWinnerList{
    constructor(
      public data:any,
      public campaignId:any
    ) {}
  }